import * as React from "react";
import PropTypes from "prop-types";
import TComboBox from "../../../Library/ComboBoxes/TComboBox";
import * as SCConst from "../NonComponents/SCConst.js";
import { getIndicatorName, getArrayAsOneBased } from "../NonComponents/SCDataUtil.js";

class SCComboBoxServiceDeliveryModes extends React.Component {
    //==================================================================================================================
    //
    //                                             Props and State
    //
    //==================================================================================================================

    static propTypes = {
        indInfo: PropTypes.object,
        siteCharByTimeInfo: PropTypes.object,
        mstIDsObj: PropTypes.object,
        itemIndex: PropTypes.number,
        onChange: PropTypes.func,
    };

    static defaultProps = {
        indInfo: null,
        siteCharByTimeInfo: null,
        mstIDsObj: null,
        itemIndex: 0,
        onChange: () => console.log("onChange"),
    };

    state = {
        title: getIndicatorName(SCConst.servDelivModeIndMstID, this.props.indInfo, this.props.mstIDsObj),
        names: getArrayAsOneBased(
            JSON.parse(JSON.stringify(this.props.siteCharByTimeInfo))[SCConst.servDelivModeNames]
        ),
    };

    //==================================================================================================================
    //
    //                                                Render
    //
    //==================================================================================================================

    render() {
        let styles = {
            combobox: {
                margin: "0 0 20px 0",
            },
        };

        return (
            <TComboBox
                caption={this.state.title}
                items={this.state.names}
                itemIndex={this.props.itemIndex}
                width="250px"
                onChange={this.props.onChange}
                outerStyle={styles.combobox}
            />
        );
    }
}

export default SCComboBoxServiceDeliveryModes;
